import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const App = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Main = styled.div`
  flex: 1;
  background: #fff;
  min-height: calc(100vh - 288px);
`;
